export const DRAWER_WIDTH = 256;
export const RAIL_WIDTH = 72;
